(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reeberger-product-launch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reeberger-product-gallery')) {
    customElements.define(
      'reeberger-product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();
          this.mainImage = this.querySelector('.rb-product-media__image');
          this.thumbnails = Array.from(this.querySelectorAll('[data-rb-gallery-thumbnail]'));

          for (const thumbnail of this.thumbnails) {
            thumbnail.addEventListener('click', () => this.selectImage(thumbnail), {
              signal: this.controller.signal,
            });
            thumbnail.addEventListener(
              'keydown',
              (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  this.selectImage(thumbnail);
                }
              },
              { signal: this.controller.signal }
            );
          }
        }

        disconnectedCallback() {
          this.controller?.abort();
        }

        selectImage(thumbnail) {
          if (!this.mainImage) return;

          this.mainImage.src = thumbnail.dataset.fullSrc;
          this.mainImage.srcset = thumbnail.dataset.fullSrcset;
          this.mainImage.sizes = '(max-width: 820px) calc(100vw - 68px), min(45vw, 520px)';
          this.mainImage.alt = thumbnail.dataset.fullAlt || '';

          if (thumbnail.dataset.fullWidth) {
            this.mainImage.width = Number(thumbnail.dataset.fullWidth);
          }

          if (thumbnail.dataset.fullHeight) {
            this.mainImage.height = Number(thumbnail.dataset.fullHeight);
          }

          for (const item of this.thumbnails) {
            item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
